"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var Client = /** @class */ (function () {
    function Client(baseUrl) {
        if (baseUrl === void 0) { baseUrl = ''; }
        this.defAxiosOptions = {
            baseURL: baseUrl,
            timeout: 5000,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            xsrfHeaderName: 'X-CSRFTOKEN',
            xsrfCookieName: 'csrftoken',
            withCredentials: true,
        };
    }
    Client.prototype.getApi = function (axiosOpts) {
        if (axiosOpts === void 0) { axiosOpts = {}; }
        return axios_1.default.create(__assign(__assign({}, this.defAxiosOptions), axiosOpts));
    };
    return Client;
}());
exports.default = {
    client: function (baseUrl) {
        if (baseUrl === void 0) { baseUrl = ''; }
        return new Client(baseUrl);
    },
};
